import { render, staticRenderFns } from "./zhichu2wayxg.vue?vue&type=template&id=9796ff0a&scoped=true&"
import script from "./zhichu2wayxg.vue?vue&type=script&lang=js&"
export * from "./zhichu2wayxg.vue?vue&type=script&lang=js&"
import style0 from "./zhichu2wayxg.vue?vue&type=style&index=0&id=9796ff0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9796ff0a",
  null
  
)

export default component.exports